import React, { useReducer, useContext, useMemo } from 'react';
function dndReducer(state, action) {
    switch (action.type) {
        case 'drag-start': {
            return {
                dragItem: action.dragItem,
            };
        }
        case 'drop': {
            return {
                dragItem: null,
            };
        }
    }
}
const initialDndState = {
    dragItem: null,
};
const dndContext = React.createContext(undefined);
export const DndProvider = (props) => {
    // NOTE: On each call, `state` and `dispatch` are identical respectively,
    // however the identity of the entire return value of the `useReducer` (`[state, dispatch]`) is not guaranteed.
    const [state, dispatch] = useReducer(dndReducer, initialDndState);
    const stateAndDispatch = useMemo(() => [state, dispatch], [state, dispatch]);
    return (React.createElement(dndContext.Provider, { value: stateAndDispatch }, props.children));
};
export const useDndStart = () => {
    const stateAndDispatch = useContext(dndContext);
    if (stateAndDispatch == null) {
        throw new Error('DndProvider is not set up.');
    }
    const [, dispatch] = stateAndDispatch;
    // NOTE: React guarantees that dispatch function identity is stable and won’t change on re-renders,
    // therefore it's unnecessary to add `dispatch` to the dependency list.
    // ( See https://reactjs.org/docs/hooks-reference.html#usereducer )
    // However, here it is because react-hooks eslint rule is not smart enough to detect the `dispatch` here comes from `useReducer` through Context.
    return useMemo(() => {
        const dragStartHandler = (dragItem) => {
            dispatch({ type: 'drag-start', dragItem });
        };
        return dragStartHandler;
    }, [dispatch]);
};
export const useDndEnd = () => {
    const stateAndDispatch = useContext(dndContext);
    if (stateAndDispatch == null) {
        throw new Error('DndProvider is not set up.');
    }
    const [state, dispatch] = stateAndDispatch;
    // NOTE: React guarantees that dispatch function identity is stable and won’t change on re-renders,
    // therefore it's unnecessary to add `dispatch` to the dependency list.
    // ( See https://reactjs.org/docs/hooks-reference.html#usereducer )
    // However, here it is because react-hooks eslint rule is not smart enough to detect the `dispatch` here comes from `useReducer` through Context.
    return useMemo(() => {
        const dropHandler = () => {
            dispatch({ type: 'drop' });
        };
        return [state.dragItem, dropHandler];
    }, [state.dragItem, dispatch]);
};
//# sourceMappingURL=dnd.js.map